import { WagmiProvider, createConfig, custom, http } from 'wagmi'

import { arbitrum, mainnet, bsc } from 'wagmi/chains'
import { walletConnect, injected, coinbaseWallet } from 'wagmi/connectors'
import getNodeUrl from '../utils/getRpcUrl'
const customRPC = getNodeUrl()

const wcMetadata = {
  name: 'RAIN',
  description: 'Decentralized Predictions Market Protocol',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://rain.wtf',
  icons: ['https://rain.wtf/assets/rain-logo.svg'],
};

const WC_PROJECT_ID = '14808831369ecdaaab7b8869eb13c6b0';

export const config = createConfig({
  chains: [arbitrum, mainnet, bsc],
  connectors: [
    injected(),
    walletConnect({
      projectId: WC_PROJECT_ID,
      showQrModal: true,
      metadata: wcMetadata,
    }),
    coinbaseWallet({
      appName: 'RAIN Protocol',
    }),
  ],
  transports: {
    [arbitrum.id]: http(customRPC),
    [mainnet.id]: http(customRPC),
    [bsc.id]: http(customRPC),
  },
})
